// Utility functions for CV formatting

/**
 * Format full name with academic degrees
 * @param {string} fullName - User's full name
 * @param {string} degreePrefix - Degree before name (e.g., Dr., Prof.)
 * @param {string} degreeSuffix - Degree after name (e.g., S.Kom., M.T., Ph.D.)
 * @returns {string} Formatted name with degrees
 */
export const formatNameWithDegree = (fullName, degreePrefix = '', degreeSuffix = '') => {
  if (!fullName) return '';
  
  let name = fullName;
  
  // Add prefix degree
  if (degreePrefix && degreePrefix.trim()) {
    name = `${degreePrefix.trim()} ${name}`;
  }
  
  // Add suffix degree
  if (degreeSuffix && degreeSuffix.trim()) {
    name = `${name}, ${degreeSuffix.trim()}`;
  }
  
  return name;
};

/**
 * Get formatted name from user object
 * @param {Object} user - User object containing full_name, degree_prefix, degree_suffix
 * @returns {string} Formatted name with degrees
 */
export const getFormattedUserName = (user) => {
  if (!user) return '';
  return formatNameWithDegree(
    user.full_name,
    user.degree_prefix,
    user.degree_suffix
  );
};

/**
 * Format date for display
 * @param {string} dateString - Date string
 * @param {string} locale - Locale code (default: 'id-ID')
 * @returns {string} Formatted date
 */
export const formatDate = (dateString, locale = 'id-ID') => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString(locale, { year: 'numeric', month: 'long' });
  } catch (error) {
    return dateString;
  }
};

/**
 * Check if certificate is expired
 * @param {string} expiryDate - Expiry date string
 * @returns {boolean} True if expired
 */
export const isCertificateExpired = (expiryDate) => {
  if (!expiryDate) return false;
  try {
    return new Date(expiryDate) < new Date();
  } catch (error) {
    return false;
  }
};
